var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragdrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 249,
    viewBox: "0 0 249 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.5,
    cy: 124.5,
    r: 124.5,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139 139.85H97C95.4536 139.85 94.2 138.611 94.2 137.083V81.75C94.2 80.222 95.4536 78.9833 97 78.9833H104V77.6C104 76.6526 104.096 75.7272 104.28 74.8333H97C93.134 74.8333 90 77.9301 90 81.75V137.083C90 140.903 93.134 144 97 144H139C142.866 144 146 140.903 146 137.083V130.167H141.8V137.083C141.8 138.611 140.546 139.85 139 139.85Z",
    fill: "#757070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.2 90.05L129.2 63.7667",
    stroke: "#757070",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6 90.7417H156.5V124.633C156.5 127.307 154.306 129.475 151.6 129.475H109.6C106.894 129.475 104.7 127.307 104.7 124.633V69.3C104.7 66.626 106.894 64.4583 109.6 64.4583H128.5V88.6667V90.7417H130.6Z",
    stroke: "#757070",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 103.883H141.8",
    stroke: "#757070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 110.108H129.9",
    stroke: "#757070",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdrop);
export default __webpack_public_path__ + "static/media/dragdrop.7a5b341fd658e0e17c7b1c10918df5f9.svg";
export { ForwardRef as ReactComponent };